import { useEffect, useState } from 'react'
import type { RefObject } from 'react'

/**
 * Czy element zjechał z ekranu w górę albo jeszcze na niego nie wszedł — `true`, gdy NIE
 * przecina się z ekranem. `initial` to odpowiedź przed pierwszym pomiarem (i bez
 * IntersectionObserver): przycisk hero stoi na ekranie od pierwszej klatki, przycisk pod
 * odpowiedziami FAQ — nie.
 */
export function useGone(ref: RefObject<HTMLElement | null>, initial = false): boolean {
  const [gone, setGone] = useState(initial)
  useEffect(() => {
    const el = ref.current
    if (!el || typeof IntersectionObserver !== 'function') return
    const io = new IntersectionObserver(([e]) => setGone(!e.isIntersecting), { threshold: 0 })
    io.observe(el)
    return () => io.disconnect()
  }, [ref])
  return gone
}
